import { render, staticRenderFns } from "./mapaZonasCobertura.vue?vue&type=template&id=24dc1941&"
import script from "./mapaZonasCobertura.vue?vue&type=script&lang=js&"
export * from "./mapaZonasCobertura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports